function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../routes/history';
import { logPath, checkUser } from '../redux/auth/authActions';
import { LOGIN_PATH } from '../routes/auth/constants';
export const requireAuth = ChildComponent => {
  class ComposedComponent extends Component {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "handleAuthCheck", () => {
        if (!this.props.isLoggedIn) {
          this.props.logPath(history.location.pathname);
          history.push(LOGIN_PATH);
        }
      });

      _defineProperty(this, "handleAuthValid", () => {
        this.props.checkUser();
      });

      _defineProperty(this, "componentDidMount", () => {
        this.handleAuthCheck();

        if (this.props.isLoggedIn) {
          this.handleAuthValid();
        }
      });

      _defineProperty(this, "componentDidUpdate", () => {
        this.handleAuthCheck();
      });

      _defineProperty(this, "render", () => {
        return /*#__PURE__*/React.createElement(ChildComponent, this.props);
      });
    }

  }

  function mapStateToProps(state) {
    return {
      isLoggedIn: state.auth.isLoggedIn,
      userToken: state.auth.token
    };
  }

  return connect(mapStateToProps, {
    logPath,
    checkUser
  })(ComposedComponent);
};